export default "__VITE_ASSET__cd81ccc1__"